export const colors = {
  orange: "#e66525",
  grey: "#9093a5",
  lightGrey: "#e2e3ea",
  darkGrey: "#5b6079",
  darkestGrey: "#353a52",
  greyfade10: "rgba(#353a52, 10%)",
};
